import { configApi } from 'config';
import { api } from './api';
import { DashboardConfig } from 'types/dashboard-config';

export class configurationsService {
    static async getUserDashboardConfig(userId: string, companyId: string): Promise<any> {
        const response = await api.get(
            `${configApi.rubricae.url}/onboarding/v1/configurations/dashboards/${userId}/?companyId=${companyId}`
        );
        return response.data;
    }

    static async getCompanyDashboardConfig(companyId: string): Promise<any> {
        const response = await api.get(
            `${configApi.rubricae.url}/onboarding/v1/configurations/dashboards/${companyId}/?companyId=${companyId}`
        );
        return response.data;
    }

    static async updateUserDashboardConfig(userId: string, body: DashboardConfig): Promise<any> {
        const response = await api.patch(`${configApi.rubricae.url}/onboarding/v1/configurations/dashboards/${userId}`, body);
        return response.data;
    }

    static async updateCompanyDashboardConfig(companyId: string, body: DashboardConfig): Promise<any> {
        const response = await api.patch(`${configApi.rubricae.url}/onboarding/v1/configurations/dashboards/${companyId}`, body);
        return response.data;
    }

    static async createDashboardConfig(body: DashboardConfig): Promise<any> {
        const response = await api.post(`${configApi.rubricae.url}/onboarding/v1/configurations/dashboards`, body);
        return response.data;
    }

    static async deleteUserDashboardConfig(userId: string, companyId: string): Promise<any> {
        const response = await api.delete(
            `${configApi.rubricae.url}/onboarding/v1/configurations/dashboards/${userId}/?companyId=${companyId}`
        );
        return response.data;
    }

    static async deleteCompanyDashboardConfig(companyId: string): Promise<any> {
        const response = await api.delete(
            `${configApi.rubricae.url}/onboarding/v1/configurations/dashboards/${companyId}/?companyId=${companyId}`
        );
        return response.data;
    }
}
